"use client"

import { useState } from "react"
import { ChevronDown } from "lucide-react"
import "./grades.css"

const GradesThree= () => {
  const [activePhase, setActivePhase] = useState(1)
  const [showDetails, setShowDetails] = useState(false)
  const [activeTab, setActiveTab] = useState(0)

  const phases = [
    {
      id: 1,
      number: 1,
      title: "مرحلة القيادة الأخلاقية        ",
      description:"ورشة عمل تناقش أنماط الشخصية من منظور القيادة الإشرافية، والممارسات المهنية والأخلاقية ذات الصلة بالحقوق والواجبات.",
      
      details: [
        {
          tab: "القيادة الأخلاقية ",
          content: [
          "الوعي الذاتي",
          "الأخلاق المهنية",
          "النزاهة",
          "إدارة المحادثات",
          "الدعم",
          "القيم",
          "المواجهة",
          "بناء الثقة",

          ]
        },
      
       
      ],
    },
    {
      id: 2,
      number: 2,
      title: "مرحلة التغيير وتوجهات المستقبل",
      description:
        "ورشة عمل تعرض لآليات رسم التوجه التشغيلي المبني على معلومات، وتتعرض لمقاومة التغيير ووسائل التغلب عليها، واستراتيجيات التغيير التدريجي ووضع الخطط الكفيلة بنجاحه.",
      details: [
        {
          tab: "التغيير وتوجهات المستقبل",
          content: [
            "تطوير الإستراتيجية",
            "قيادة التغيير",
            "تقييم المخاطرات",
            "النظرة المستقبلية",
            "الإِبداع",
            "الالهام",
            "الابتكار",
            "الريادة",
   
             ]
        },
      
      ],
    },
    {
      id: 3,
      number: 3,
      title: "  مرحلة العافية المهنية    ",
      description:
        "ورشة عمل تتناول شروط بيئة العمل الإيجابية، وآليات تحقيق التوازن بين حياة الشخصية ومتطلبات العمل للفرد والجماعة، ومناهج قيادة الفرق وربطها بالمنظمة مع تحقيق أهداف أعضائها التطويرية.",
      details: [
        {
          tab: " العافية المهنية ",
          content: [
          'بيئة العمل',
          'إدارة الأداء',
          'المرونة',
          'التكيف',
          'الإرشاد',
          'توليد النتائج',
          'الموارد البشرية',
               ]
        },
      
      
      ],
    },
    {
      id: 4,
      number: 4,
      title: "مرحلة المعلومات والقرار",
      description: "ورشة عمل تركز على مهارات التفكير والتحليل واتخاذ القرار في السياقات المختلفة، وأهمها قيادة الجهد الجماعي وتوجيه الأداء الفردي.",
      details: [
        {
          tab: "المعلومات والقرار ",
          content: [
          "المبادرة",
          "الدراسة والتحليل",
          "الإدارة التصاعدية",
          "تمكين الكوادر",
          "التعلم من الأخطاء",
          "إدارة الوقت",
          "صناعة القرار",
          "علاج المشكلات",
          "التفكير الناقد",
          "المسؤولية الاجتماعية",
          "التعلم",
          "العلامة التجارية الشخصية",
                 ]
        },
       
       
      ],
    },
    {
      id: 5,
      number: 5,
      title: "مرحلة العلاقات التنظيمية",
      description: "ورشة عمل تعنى بمهارات بناء وصيانة العلاقة مع الأطراف أصحاب المصلحة داخل وخارج المنظمة، في سياقات التواصل المؤسسي والتشبيك وقيادة المشروعات وإدارة علاقات العملاء.",
      details: [
        {
          tab: "العلاقات التنظيمية",
            content: [
             'العمل الجماعي',
             'التشبيك',
             'قيادة المشروعات',
             'الاحترام وحسن التصرف',
             'إشراك أصحاب المصلحة',
             'التنوع الثقافي',
             'إدارة علاقات العملاء',
             'التفاوض',
             'إدارة الاجتماعات',
             'التواصل',
            ],
        },
       
       
      ],
    },
  ]

  const handlePhaseClick = (phaseId) => {
    setActivePhase(phaseId)
    setShowDetails(false)
  }

  const toggleDetails = () => {
    setShowDetails(!showDetails)
    setActiveTab(0)
  }

  const handleTabClick = (index) => {
    setActiveTab(index)
  }

  const activePhaseData = phases.find((phase) => phase.id === activePhase)

  return (
    <div className="program-design-container">
      <div className="program-header-g">
        <h2 className="program-title">فلسفة تصميم البرنامج</h2>
        <div className="program-subtitle">
        يمتد البرنامج خمسة أشهر، يتعرض المشارك لعدد كبير ونماذج متنوعة من سيناريوهات فرق العمل ودراسات الحالة، ومهام التخطيط التنفيذي وتقييم وتوجيه الجهود الفردية والجماعية.




</div>
      </div>

      <div className="program-content">
        <div className="phases-details">
          <h3 className="details-title">تفاصيل المرحلة</h3>
          <div className="details-content">{activePhaseData.description}</div>

          <button className="details-toggle" onClick={toggleDetails}>
            <span>تفاصيل المرحلة</span>
            <ChevronDown className={`details-icon ${showDetails ? "rotated" : ""}`} />
          </button>

          {showDetails && (
  <div className="details-tabs">
    <div className="tabs-header">
      {activePhaseData.details.map((detail, index) => (
        <button
          key={index}
          className={`tab-button ${activeTab === index ? "active" : ""}`}
          onClick={() => handleTabClick(index)}
        >
          {detail.tab}
        </button>
      ))}
    </div>
    <div className="tab-content">
      <ul>
        {activePhaseData.details[activeTab].content.map((item, index) => (
          <li key={index}><i class="far fa-check-circle"></i>{item}</li>
        ))}
      </ul>
    </div>
  </div>
)}

        </div>

        <div className="phases-list">
          {phases.map((phase) => (
            <div
              key={phase.id}
              className={`phase-item ${activePhase === phase.id ? "active" : ""}`}
              onClick={() => handlePhaseClick(phase.id)}
            >
              <div className="phase-number">{phase.number}</div>
              <div className="phase-title">{phase.title}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default GradesThree
